export default class AppValidator {
    constructor(store) {
        this.errors = [];
        this.store = store;
        this.validables = [];
        this.onNextCbs = [];
    }

    isValid() {
        this.errors = [];
        this.validables.forEach((validator) => {
            this.errors = [...this.errors, ...validator()];
        });
        // console.log(this.errors)
        return this.errors.length === 0;
    }

    addValidator(validable) {
        if (typeof validable !== 'function') {
            throw new Error('Paraméter validátor nem function típusú');
        }
        this.validables.push(validable);
    }

    addOnNextCb(func) {
        if (typeof func !== 'function') {
            throw new Error('Paraméter objektum nem function típusú');
        }
        this.onNextCbs.push(func);
    }

    getErrors() {
        return this.errors;
    }

    getOnNextCbs() {
        return this.onNextCbs;
    }

    clear() {
        this.error = [];
        this.validables = [];
        this.onNextCbs = [];
    }
}
